import React from 'react';
import axios from 'axios';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import Modal from '../../components/layout/Modal';
import Grid, { GridItem } from '../../components/layout/Grid';
import CampoSeletor from '../../components/Formulario/CampoSeletor';
import CampoData from '@/components/Formulario/CampoData';
import CampoNumero from '@/components/Formulario/CampoNumero';
import Descricao from '../../components/tipografia/Descricao';

const frequenciaOptions = [
  { id: 'semanal', label: 'Semanal' },
  { id: 'mensal', label: 'Mensal' },
  { id: 'trimestral', label: 'Trimestral' },
  { id: 'semestral', label: 'Semestral' },
  { id: 'anual', label: 'Anual' },
];

export const ModalTransformarRecorrencia = ({
  lancamento,
  onClose,
  onSuccess,
}: {
  lancamento: any;
  onClose: () => void;
  onSuccess: () => void;
}) => {
  const [frequencia, setFrequencia] = React.useState<string>('mensal');
  const [dataFim, setDataFim] = React.useState<string>('');
  const [diasAntecedencia, setDiasAntecedencia] = React.useState<number>(30);

  const mutator = useMutation(
    async () => {
      return await axios.post(
        `/api/lancamento_financeiro/${lancamento.id}/transformar_recorrencia`,
        {
          frequencia,
          data_fim: dataFim || undefined,
          dias_antecedencia_geracao: diasAntecedencia,
        },
      );
    },
    {
      onSuccess: () => {
        toast('Recorrência criada com sucesso', {
          toastId: 'recorrencia-success',
          position: 'top-center',
          type: 'success',
          autoClose: 5000,
        });
        onSuccess();
      },
      onError: (err: any) => {
        toast(err.response?.data?.msg ?? 'Erro ao criar recorrência', {
          toastId: 'recorrencia-error',
          position: 'top-center',
          type: 'warning',
          autoClose: 5000,
        });
      },
    },
  );

  return (
    <Modal
      instanceId="modal-transformar-recorrencia"
      title="Transformar em recorrência"
      show={!!lancamento}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={() => mutator.mutate()}
      confirmProps={{ label: 'Criar recorrência', disabled: mutator.isLoading }}
    >
      <Descricao>
        A partir de agora, "{lancamento?.descricao}" vai gerar automaticamente
        novos lançamentos com a frequência escolhida.
      </Descricao>
      <Grid>
        <GridItem sm={12} md={6}>
          <CampoSeletor
            noSearch
            label="Frequência"
            value={frequencia}
            onChange={setFrequencia}
            options={frequenciaOptions}
          />
        </GridItem>
        <GridItem sm={12} md={6}>
          <CampoNumero
            label="Dias de antecedência"
            value={diasAntecedencia}
            onChange={setDiasAntecedencia}
            append={<span>dias antes do vencimento</span>}
          />
        </GridItem>
        <GridItem sm={12} md={6}>
          <CampoData
            label="Data fim (opcional)"
            value={dataFim}
            onChange={setDataFim}
          />
        </GridItem>
      </Grid>
    </Modal>
  );
};

export default ModalTransformarRecorrencia;
